/**
 * Extracts values from text field elements in a form and maps the values to the names of the inputs. The
 * result is returned as an object. Empty inputs will be mapped to an empty string.
 */

const getFormElementValues = htmlFormElement =>
  Array.from(htmlFormElement.elements).reduce(
    (all, el) =>
      el.name === ''
        ? all
        : {
            ...all,
            [el.name]: el.value,
          },
    {},
  );

export default getFormElementValues;
